import { cva } from 'components/lib';

const Variants = cva(

  `relative w-full rounded-lg border backdrop-blur-md
  p-6 pl-14 [&>p]:!mb-0
  [&>svg]:left-6
  [&>svg]:top-[1.65em]
  [&>svg+div]:translate-y-[-3px]
  [&>svg]:absolute
  [&>h2]:font-semibold
  [&>h2]:text-lg
  [&>p]:leading-relaxed
  [&>button]:mt-2
  poppins-light`,

  {
    variants: {
      variant: {
        default:
          'bg-white/10 border-white/20 text-white/90 [&>svg]:text-white/80',
        info:
          `bg-blue-500/10 border-blue-400/30 text-blue-200 [&>svg]:text-blue-300
          [&>h2]:text-blue-300 [&>p]:text-blue-200/90`,
        success:
          `bg-emerald-500/10 border-emerald-400/30 text-emerald-200 [&>svg]:text-emerald-300
          [&>h2]:text-emerald-300 [&>p]:text-emerald-200/90`,
        warning:
          `bg-orange-500/10 border-orange-400/30 text-orange-200 [&>svg]:text-orange-300
          [&>h2]:text-orange-300 [&>p]:text-orange-200/90`,
        error:
          `bg-red-500/10 border-red-400/30 text-red-200 [&>svg]:text-red-300
          [&>h2]:text-red-300 [&>p]:text-red-200/90`,
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
)

export { Variants }